function n(n, r, t) {
  return {
    r: 255 * t(n.r / 255, r.r / 255),
    g: 255 * t(n.g / 255, r.g / 255),
    b: 255 * t(n.b / 255, r.b / 255)
  };
}
function r(n, r) {
  return r;
}
function t(n, r) {
  return n * r;
}
function u(n, r) {
  return n + r - n * r;
}
function i(n, r) {
  return a(r, n);
}
function o(n, r) {
  return Math.min(n, r);
}
function e(n, r) {
  return Math.min(Math.max(n, r), 1);
}
function c(n, r) {
  return 0 === n ? 0 : 1 === r ? 1 : Math.min(1, n / (1 - r));
}
function f(n, r) {
  return 1 === n ? 1 : 0 === r ? 0 : 1 - Math.min(1, (1 - n) / r);
}
function a(n, r) {
  return r <= .5 ? t(n, 2 * r) : u(n, 2 * r - 1);
}
function b(n, r) {
  return r <= .5 ? n - (1 - 2 * r) * n * (1 - n) : n + (2 * r - 1) * ((n <= .25 ? ((16 * n - 12) * n + 4) * n : Math.sqrt(n)) - n);
}
function g(n, r) {
  return Math.abs(n - r);
}
function h(n, r) {
  return n + r - 2 * n * r;
}
function M(n, r, t) {
  return Math.min(Math.max(n || 0, r), t);
}
function m(n) {
  return {
    r: M(n.r, 0, 255),
    g: M(n.g, 0, 255),
    b: M(n.b, 0, 255),
    a: M(n.a, 0, 1)
  };
}
function d(n) {
  return {
    r: 255 * n.r,
    g: 255 * n.g,
    b: 255 * n.b,
    a: n.a
  };
}
function p(n) {
  return {
    r: n.r / 255,
    g: n.g / 255,
    b: n.b / 255,
    a: n.a
  };
}
function v(n, r) {
  void 0 === r && (r = 0);
  var t = Math.pow(10, r);
  return {
    r: Math.round(n.r * t) / t,
    g: Math.round(n.g * t) / t,
    b: Math.round(n.b * t) / t,
    a: n.a
  };
}
function x(n, r, t, u, i, o) {
  return (1 - r / t) * u + r / t * Math.round((1 - n) * i + n * o);
}
function O(n, r, t, u, i) {
  void 0 === i && (i = {
    unitInput: !1,
    unitOutput: !1,
    roundOutput: !0
  }), i.unitInput && (n = d(n), r = d(r)), n = m(n);
  var o = (r = m(r)).a + n.a - r.a * n.a,
    e = t(n, r, u),
    c = m({
      r: x(n.a, r.a, o, n.r, r.r, e.r),
      g: x(n.a, r.a, o, n.g, r.g, e.g),
      b: x(n.a, r.a, o, n.b, r.b, e.b),
      a: o
    });
  return c = i.unitOutput ? p(c) : i.roundOutput ? v(c) : function (n) {
    return v(n, 9);
  }(c), c;
}
function s(n, r, t) {
  return d(t(p(n), p(r)));
}
function I(n) {
  return .3 * n.r + .59 * n.g + .11 * n.b;
}
function q(n, r) {
  var t = r - I(n);
  return function (n) {
    var r = I(n),
      t = n.r,
      u = n.g,
      i = n.b,
      o = Math.min(t, u, i),
      e = Math.max(t, u, i);
    function c(n) {
      return r + (n - r) * r / (r - o);
    }
    function f(n) {
      return r + (n - r) * (1 - r) / (e - r);
    }
    return o < 0 && (t = c(t), u = c(u), i = c(i)), e > 1 && (t = f(t), u = f(u), i = f(i)), {
      r: t,
      g: u,
      b: i
    };
  }({
    r: n.r + t,
    g: n.g + t,
    b: n.b + t
  });
}
function w(n) {
  return Math.max(n.r, n.g, n.b) - Math.min(n.r, n.g, n.b);
}
function j(n, r) {
  var t = ["r", "g", "b"].sort(function (r, t) {
      return n[r] - n[t];
    }),
    u = t[0],
    i = t[1],
    o = t[2],
    e = {
      r: n.r,
      g: n.g,
      b: n.b
    };
  return e[o] > e[u] ? (e[i] = (e[i] - e[u]) * r / (e[o] - e[u]), e[o] = r) : e[i] = e[o] = 0, e[u] = 0, e;
}
function k(n, r) {
  return q(j(r, w(n)), I(n));
}
function l(n, r) {
  return q(j(n, w(r)), I(n));
}
function y(n, r) {
  return q(r, I(n));
}
function z(n, r) {
  return q(n, I(r));
}
function A(t, u) {
  return O(t, u, n, r);
}
function B(r, u) {
  return O(r, u, n, t);
}
function C(r, t) {
  return O(r, t, n, u);
}
function D(r, t) {
  return O(r, t, n, i);
}
function E(r, t) {
  return O(r, t, n, o);
}
function F(r, t) {
  return O(r, t, n, e);
}
function G(r, t) {
  return O(r, t, n, c);
}
function H(r, t) {
  return O(r, t, n, f);
}
function J(r, t) {
  return O(r, t, n, a);
}
function K(r, t) {
  return O(r, t, n, b);
}
function L(r, t) {
  return O(r, t, n, g);
}
function N(r, t) {
  return O(r, t, n, h);
}
function P(n, r) {
  return O(n, r, s, k);
}
function Q(n, r) {
  return O(n, r, s, l);
}
function R(n, r) {
  return O(n, r, s, y);
}
function S(n, r) {
  return O(n, r, s, z);
}
export { R as color, H as colorBurn, G as colorDodge, E as darken, L as difference, N as exclusion, J as hardLight, P as hue, F as lighten, S as luminosity, B as multiply, A as normal, D as overlay, Q as saturation, C as screen, K as softLight };